<template>
	<modal name="user-settings" :width="300" :height="400">
		<div id="user-settings-modal">
			<h1>{{ $t('userSettingsModal.title') }}</h1>
			<IconTimes class="close-modal" @click.native="$modal.hide('user-settings')" />
			<p>
				<strong>{{ $t('userSettingsModal.loggedUser') }}</strong><br>
				{{ currentUser.email }}
			</p>
			<button type="button" @click="restartLastPlayedDatetime" v-if="!isAnonymous && networkOnline">{{ $t('userSettingsModal.refreshPlayedSongs') }}</button>
			<button type="button" @click="logout" v-if="!isAnonymous && networkOnline">{{ $t('userSettingsModal.logout') }}</button>
			<button type="button" class="button-delete-account" @click="deleteAccount" v-if="!isAnonymous && networkOnline">{{ $t('userSettingsModal.deleteAccount') }}</button>
		</div>
	</modal>
</template>

<script>
	import { auth } from "@/firebase";
	import { mapState } from "vuex";
	import { SongService } from "@/services/SongService";
	import IconTimes from "@/components/icons/IconTimes";
	import firebase from "firebase";

	export default {
		components: {
			IconTimes
		},
		computed: {
			...mapState([ "currentUser", "songs", "networkOnline" ]),
			isAnonymous() {
				return this.currentUser === null || this.currentUser.isAnonymous;
			}
		},
		methods: {
			logout() {
				this.$notify({
					type: "success",
					text: this.$t('success.logout'),
				});

				auth.signOut().then(() => {
					window.location.reload();
				});
			},
			deleteAccount() {
				if (window.confirm(this.$t('userSettingsModal.deleteAccountConfirm'))) {
					const functionDeleteAccount = firebase.functions().httpsCallable("deleteAccount");
					functionDeleteAccount({ uid: this.$store.state.currentUser.uid });
					auth.signOut().then(() => {
						window.location.reload();
					});
				}
			},
			restartLastPlayedDatetime() {
				Object.values(this.songs).map(s => {
					if (s.lastPlayedDatetime !== null) {
						SongService.restartLastPlayedDatetime(s);
					}
				});
				this.$notify({
					type: "success",
					text: this.$t('success.playedSongsRefreshed'),
				});
			}
		},
	}
</script>

<style lang="scss" scoped>
	#user-settings-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-weight: 300;

		.close-modal {
			fill: white;
			width: 20px;
			opacity: 0.5;
			position: absolute;
			top: 20px;
			right: 20px;
			cursor: pointer;

			&:hover {
				opacity: 1;
			}
		}

		h1 {
			margin: 0;
			padding: 20px;
			font-size: 1.4em;
			font-weight: 100;
		}

		p {
			margin: 0 20px 20px 20px;
		}

		input {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background-color: rgba(255, 255, 255, 0.21);
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin-bottom: 1px;

			&::placeholder {
				color: rgba(255, 255, 255, 0.49);
			}

			&:focus {
				outline: none;
			}
		}

		button {
			font-weight: 100;
			margin: 5px 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #356173;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				background-color: #2f4f5f;
			}

			&:focus {
				outline: none;
			}

			&.button-delete-account {
				margin-top: 40px;
				background-color: #ac4b6c;
				line-height: 35px;

				&:hover {
					background-color: #883b55;
				}
			}
		}

	}
</style>
